(function () {
  'use strict';
  var VERSION = 'loaded-width-v2-clamped';
  var IDS = new Set(['668267348186', '664763629786', '668291760346',
    '588691800282', '588775391450', '588676792538', '588692226266',
    '665026724058', '588692029658']);
  var SELECTOR = '.ntf-article-image-layout-v2[data-ntf-article-images]';
  if (window.NTFArticleImagesV2 && window.NTFArticleImagesV2.version === VERSION) {
    window.NTFArticleImagesV2.init(document);
    return;
  }
  var states = new WeakMap();
  var active = new Set();

  function eligible(image, wrapper) {
    var style = image.getAttribute('style');
    var paragraph = image.closest('p[style]');
    return (style === null || style === 'float: none;') &&
      !(paragraph && wrapper.contains(paragraph));
  }

  function updateBleed(state) {
    var wrapper = state.wrapper;
    var rect = wrapper.getBoundingClientRect();
    var viewportWidth = document.documentElement.clientWidth;
    var desktop = window.innerWidth >= 590;
    var limit = desktop ? 50 : 20;
    var originalExtra = desktop ? 90 : 40;
    var left = Math.max(0, Math.min(limit, rect.left));
    var right = Math.max(0, Math.min(limit, viewportWidth - rect.right));
    var extra = Math.min(originalExtra, left + right);
    var values = { '--ntf-image-bleed-left': left + 'px',
      '--ntf-image-bleed-right': right + 'px', '--ntf-image-extra': extra + 'px' };
    Object.keys(values).forEach(function (name) {
      if (wrapper.style.getPropertyValue(name) !== values[name]) {
        wrapper.style.setProperty(name, values[name]);
      }
    });
    // The observer ignores only our exact resulting style, not external edits.
    state.ownWrapperStyle = wrapper.getAttribute('style');
    wrapper.dataset.ntfImageBleedLeft = String(left);
    wrapper.dataset.ntfImageBleedRight = String(right);
    wrapper.dataset.ntfImageExtra = String(extra);
  }

  function summary(state) {
    var counts = { pending: 0, error: 0, ready: 0, preserved: 0 };
    state.images.forEach(function (record, image) {
      if (!state.wrapper.contains(image)) return;
      counts[record.status] += 1;
    });
    var wrapper = state.wrapper;
    wrapper.dataset.ntfPendingImages = String(counts.pending);
    wrapper.dataset.ntfErrorImages = String(counts.error);
    wrapper.dataset.ntfReadyImages = String(counts.ready);
    wrapper.dataset.ntfPreservedImages = String(counts.preserved);
    wrapper.dataset.ntfImageLayoutState = counts.pending ? 'pending' :
      (counts.error ? 'settled-with-image-error' : 'settled');
  }

  function status(state, record, value) {
    record.status = value;
    record.image.dataset.ntfImageStatus = value;
    summary(state);
  }

  function evaluate(state, record) {
    var image = record.image;
    var generation = ++record.generation;
    if (!eligible(image, state.wrapper)) {
      image.classList.remove('ntf-image-wide');
      status(state, record, 'preserved');
      return;
    }
    if (!image.complete) {
      image.classList.remove('ntf-image-wide');
      status(state, record, 'pending');
      return; // Do not eagerly load a lazy image or wait on a fixed timer.
    }
    if (image.naturalWidth <= 0) {
      image.classList.remove('ntf-image-wide');
      status(state, record, 'error');
      return;
    }
    if (!image.currentSrc) {
      image.classList.remove('ntf-image-wide');
      status(state, record, 'pending');
      return; // Positive intrinsic size without a selected source is not loaded proof.
    }
    var source = image.currentSrc;
    status(state, record, 'pending');
    var decoded;
    if (record.decodedSource === source || typeof image.decode !== 'function') {
      decoded = Promise.resolve();
    } else {
      try { decoded = Promise.resolve(image.decode()).catch(function () {}); }
      catch (error) { decoded = Promise.resolve(); }
    }
    decoded.then(function () {
      if (generation !== record.generation || !state.wrapper.contains(image)) return;
      if ((image.currentSrc || image.getAttribute('src') || '') !== source) {
        schedule(state);
        return; // A previous responsive image decode must not classify a new source.
      }
      record.decodedSource = source;
      window.requestAnimationFrame(function () {
        if (generation !== record.generation || !state.wrapper.contains(image)) return;
        if ((image.currentSrc || image.getAttribute('src') || '') !== source) {
          schedule(state);
          return;
        }
        if (!image.complete || image.naturalWidth <= 0 || !image.currentSrc) {
          image.classList.remove('ntf-image-wide');
          status(state, record, image.complete && image.naturalWidth <= 0 ? 'error' : 'pending');
          return;
        }
        var width = state.wrapper.getBoundingClientRect().width;
        if (width <= 0) {
          image.classList.remove('ntf-image-wide');
          status(state, record, 'pending');
          return; // ResizeObserver will retry when a hidden wrapper becomes visible.
        }
        var renderedWidth = image.getBoundingClientRect().width;
        image.classList.toggle('ntf-image-wide', renderedWidth + 0.5 >= width);
        status(state, record, 'ready');
      });
    });
  }

  function scan(state) {
    updateBleed(state);
    state.wrapper.querySelectorAll('img').forEach(function (image) {
      var record = state.images.get(image);
      if (!record) {
        record = { image: image, generation: 0, decodedSource: null, status: 'pending' };
        record.refresh = function () { evaluate(state, record); };
        state.images.set(image, record);
        image.addEventListener('load', record.refresh);
        image.addEventListener('error', record.refresh);
      }
      evaluate(state, record); // Listeners are installed before testing cached completion.
    });
    state.images.forEach(function (record, image) {
      if (state.wrapper.contains(image)) return;
      record.generation += 1;
      image.removeEventListener('load', record.refresh);
      image.removeEventListener('error', record.refresh);
      state.images.delete(image);
    });
    summary(state);
  }

  function destroy(state) {
    if (state.resize) state.resize.disconnect();
    if (state.mutations) state.mutations.disconnect();
    state.images.forEach(function (record, image) {
      record.generation += 1;
      image.removeEventListener('load', record.refresh);
      image.removeEventListener('error', record.refresh);
    });
    state.images.clear();
    active.delete(state);
    states.delete(state.wrapper);
  }

  function schedule(state) {
    if (state.scheduled) return;
    state.scheduled = true;
    window.requestAnimationFrame(function () {
      state.scheduled = false;
      if (!state.wrapper.isConnected) { destroy(state); return; }
      scan(state);
    });
  }

  function attach(wrapper) {
    if (!IDS.has(wrapper.dataset.ntfArticleImages)) return;
    var state = states.get(wrapper);
    if (state) { schedule(state); return; }
    state = { wrapper: wrapper, images: new Map(), scheduled: false,
      width: wrapper.getBoundingClientRect().width };
    states.set(wrapper, state);
    active.add(state);
    if (typeof ResizeObserver === 'function') {
      state.resize = new ResizeObserver(function () {
        var width = wrapper.getBoundingClientRect().width;
        if (Math.abs(width - state.width) <= 0.5) return;
        state.width = width;
        schedule(state);
      });
      state.resize.observe(wrapper);
    }
    if (typeof MutationObserver === 'function') {
      state.mutations = new MutationObserver(function (records) {
        var relevant = records.some(function (record) {
          return !(record.type === 'attributes' && record.target === wrapper &&
            record.attributeName === 'style' &&
            wrapper.getAttribute('style') === state.ownWrapperStyle);
        });
        if (relevant) schedule(state);
      });
      state.mutations.observe(wrapper, { childList: true, subtree: true, attributes: true,
        attributeFilter: ['src', 'srcset', 'sizes', 'style', 'width', 'height', 'loading'] });
    }
    scan(state);
  }

  function init(root) {
    if (root.matches && root.matches(SELECTOR)) attach(root);
    root.querySelectorAll(SELECTOR).forEach(attach);
  }
  window.NTFArticleImagesV2 = { version: VERSION, init: init };
  window.addEventListener('resize', function () { active.forEach(schedule); }, { passive: true });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    active.forEach(function (state) { if (event.target.contains(state.wrapper)) destroy(state); });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
